import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import dispatcher from 'mewe/dispatcher';
import { action } from '@ember/object';

export default class MwChatInfoMemberDropdown extends Component {
  @service chat;
  @service account;

  get canRemoveFromGroup() {
    return this.args.thread.isGroupChat && this.args.user.canRemove;
  }

  get canRemoveFromChat() {
    return this.args.thread.isMultiUsersChatOwner;
  }

  get canChat() {
    return this.account.activeUser.id !== this.args.user.id && this.args.user.canSendMessage;
  }

  @action
  startChat() {
    this.chat.openThreadByParticipants([this.args.user], { isChatOptions: true });
  }

  @action
  removeFromGroup() {
    dispatcher.dispatch('group-member', 'removeMember', this.args.user, this.args.thread.group);
  }

  @action
  removeFromChat() {
    dispatcher.dispatch('chat', 'removeChatParticipant', this.args.thread, this.args.user);
  }
}
